import * as types from './actionTypes';

export const getQueryParams = (params) => (
  {
    type: types.GET_QUERY_PARAMS,
    params,
  }
);
